import { useSearchParams } from 'react-router-dom'
import { useCallback, useMemo } from 'react'

/**
 * Filtre durumunu adres çubuğunda tutar (görev dosyası: FilterBar/DateRangePicker/
 * MultiSelect "URL senkronizasyonu"). Boş/undefined değerler parametreyi siler ki
 * URL kısa kalsın ve geri tuşu anlamlı adımlar üretsin.
 */
export function useQueryState() {
  const [searchParams, setSearchParams] = useSearchParams()

  const get = useCallback((key: string) => searchParams.get(key) ?? undefined, [searchParams])

  const getList = useCallback((key: string) => searchParams.getAll(key), [searchParams])

  const set = useCallback(
    (patch: Record<string, string | string[] | undefined>) => {
      setSearchParams(
        (previous) => {
          const next = new URLSearchParams(previous)
          for (const [key, value] of Object.entries(patch)) {
            next.delete(key)
            if (value === undefined || value === '') continue
            if (Array.isArray(value)) {
              for (const item of value) next.append(key, item)
            } else {
              next.set(key, value)
            }
          }
          return next
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  const reset = useCallback(
    (keys: string[]) => {
      set(Object.fromEntries(keys.map((key) => [key, undefined])))
    },
    [set],
  )

  return useMemo(() => ({ get, getList, set, reset }), [get, getList, set, reset])
}
